import Vue from 'vue';
// v-moveAndDrag: 左右上下拖拽属性
Vue.directive('moveAndDrag', {
  bind(el) {
  // bind(el, binding, vnode, oldVnode) {
    var box = $(el);
    // 左右
    var wResize = box.find('.dragWResizer');
    var left = box.find('.dragLeft');
    var right = box.find('.dragRight');
    // 上下
    var nResize = box.find('.dragNResizer');
    var top = box.find('.dragTop');
    var bottom = box.find('.dragBottom');
    if (wResize && wResize.length > 0) {
      for (let i = 0; i < wResize.length; i++) {
        // 鼠标按下事件
        wResize[i].onmousedown = function (e) {
          //颜色改变提醒
          var startX = e.clientX;
          wResize[i].left = wResize[i].offsetLeft;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            var endX = e.clientX;
            var moveLen = wResize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - wResize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

            if (moveLen < 190) moveLen = 190; // 左边区域的最小宽度为190px
            if (moveLen > maxT - 190) moveLen = maxT - 190; //右边区域最小宽度为190px
            wResize[i].style.left = moveLen + 'px'; // 设置左侧区域的宽度

            for (let j = 0; j < left.length; j++) {
              left[j].style.width = moveLen + 'px';
              right[j].style.width = (box[i].clientWidth - moveLen - 8) + 'px';
            }
          };
          // 鼠标松开事件
          document.onmouseup = function () {
            //颜色恢复
            document.onmousemove = null;
            document.onmouseup = null;
            wResize[i].releaseCapture && wResize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
          };
          wResize[i].setCapture && wResize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
          return false;
        };
      }
    }
    if (nResize && nResize.length > 0) {
      for (let i = 0; i < nResize.length; i++) {
        // 鼠标按下事件
        nResize[i].onmousedown = function (e) {
          //颜色改变提醒
          var startY = e.clientY;
          nResize[i].top = nResize[i].offsetTop;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            var endY = e.clientY;
            var moveLen = nResize[i].top + (endY - startY); // endY-startY=移动的距离。resize[i].top+移动的距离=上边区域最后的宽度
            var maxT = box[i].clientHeight - nResize[i].offsetHeight; // 容器高度 - 上边区域的高度 = 下边区域的高度

            if (moveLen < 124) moveLen = 124; // 上边区域的最小宽度为124px
            if (moveLen > maxT - 124) moveLen = maxT - 124; //下边区域最小宽度为124px
            nResize[i].style.top = moveLen + 'px'; // 设置上侧区域的高度

            for (let j = 0; j < top.length; j++) {
              top[j].style.height = moveLen + 'px';
              bottom[j].style.height = (box[i].clientHeight - moveLen - 8) + 'px';
              bottom[j].style.top = (moveLen + 8) + 'px';
            }
          };
          // 鼠标松开事件
          document.onmouseup = function () {
            //颜色恢复
            document.onmousemove = null;
            document.onmouseup = null;
            nResize[i].releaseCapture && nResize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
          };
          nResize[i].setCapture && nResize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
          return false;
        };
      }
    }
  }
})
Vue.directive('resize', {
  bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
    let width = '', height = '';
    function isReize() {
      const style = document.defaultView.getComputedStyle(el);
      if (width !== style.width || height !== style.height) {
        binding.value();  // 关键
      }
      width = style.width;
      height = style.height;
    }
    el.__vueSetInterval__ = setInterval(isReize, 300);
  },
  unbind(el) {
    clearInterval(el.__vueSetInterval__);
  }
})